import React from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import { Header } from "../../../components/header";
import { CardHeader } from "../../../components/cards";
import { SendIcon } from "../../../components/icons";
import { useCreatePromptFragment } from "../hooks";
import { PromptFragmentForm } from "../components";

export const CreatePromptFragment: React.FC = () => {
  const navigate = useNavigate();

  const { form, submit, loading } = useCreatePromptFragment({
    defaultValues: {},
    onCompleted: () => {
      toast.success("Le fragment a été créé avec succès");
      navigate("/prompt-fragments");
    },
  });

  return (
    <>
      <Header
        title="Fragment de prompt"
        subtitle="Créer un nouveau fragment"
        buttons={[
          {
            actionText: "Annuler",
            bgColor: "indigo",
            textColor: "white",
            link: `/prompt-fragments`,
            icon: <SendIcon />,
          },
        ]}
      />
      <div className="main-container">
        <div className="card">
          <CardHeader title="Nouveau fragment" />
          <PromptFragmentForm loading={loading} submit={submit} form={form} />
        </div>
      </div>
    </>
  );
};
